module.exports = __webpack_public_path__ + "media/images/landing__bg-233e39b8cd900493a13bf88cf1361b08.jpg";